import React from 'react'

type Props = {
  fill: string
  className: string
}

export function LargeHangerIcon({ fill, className }: Props) {
  return (
    <svg
      className={className}
      width="24"
      height="65"
      viewBox="0 0 24 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 0.5V56.5C0.5 60.9183 4.08172 64.5 8.5 64.5H23.5"
        stroke={fill}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default function ItemHangerIcon({ fill, className }: Props) {
  return (
    <svg
      className={className}
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_24626_25155" fill="white">
        <path d="M0 0H13V12H8C3.58172 12 0 8.41828 0 4V0Z" />
      </mask>
      <path
        d="M0 0H13H0ZM13 13H8C3.02944 13 -1 8.97056 -1 4H1C1 7.86599 4.13401 11 8 11H13V13ZM8 13C3.02944 13 -1 8.97056 -1 4V0H1V4C1 7.86599 4.13401 11 8 11V13ZM13 0V12V0Z"
        fill={fill}
        mask="url(#path-1-inside-1_24626_25155)"
      />
    </svg>
  )
}
